import React from 'react';
import { FaExclamationCircle } from 'react-icons/fa';

export const InputUnverifiedBadge = () => (
	<div>
		<FaExclamationCircle className="text-danger mr-1" />
		Unverified
	</div>
);
